import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import PricingPlans from "../../components/pricing/PricingPlans";
import { usePlanCatalog } from "../../hooks/usePlanCatalog";
import { Plan } from "../../config/plans";

const Pricing: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth0();
  const { catalog } = usePlanCatalog();

  // A signed-in visitor must not be bounced to /login — that redirects straight
  // back to /accounts and the upgrade silently does nothing. Send them to the
  // billing section with the plan preselected instead.
  const handleSelect = (plan: Plan) => {
    if (plan.ctaKind === "contact") return navigate("/contact");
    if (isAuthenticated) return navigate(`/settings?plan=${plan.id}#billing`);
    navigate("/login");
  };

  return (
    <section id="pricing" className="py-24 bg-background">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-heading font-bold mb-4 bg-gradient-to-r from-primary to-blue-400 bg-clip-text text-transparent">
            Simple, transparent pricing
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Pick the plan that fits your community. Upgrade or cancel any time.
          </p>
        </motion.div>

        <PricingPlans plans={catalog.plans} onSelect={handleSelect} variant="section" />
      </div>
    </section>
  );
};

export default Pricing;
